import { Consumer, createContext, Provider, useContext } from 'react';
import { CollectionState } from '../state';
import { FiltersMap } from '../model';

export const CollectionContext = createContext<CollectionState<unknown> | null>(
  null,
);

export const CollectionProvider = CollectionContext.Provider as Provider<
  CollectionState<any, any>
>;
export const CollectionConsumer = CollectionContext.Consumer as Consumer<
  CollectionState<any, any>
>;

export function useCollectionContext<C extends CollectionState<any, any>>(): C;
export function useCollectionContext<
  T,
  F extends FiltersMap,
>(): CollectionState<T, F>;

export function useCollectionContext() {
  const collectionState = useContext(CollectionContext);
  if (collectionState == null) {
    throw new Error('CollectionStoreContext: value was not provided');
  }
  return collectionState;
}
